import { render, staticRenderFns } from "./CustomDatatable.vue?vue&type=template&id=867f2ccc&scoped=true"
import script from "./CustomDatatable.vue?vue&type=script&lang=js"
export * from "./CustomDatatable.vue?vue&type=script&lang=js"
import style0 from "./CustomDatatable.vue?vue&type=style&index=0&id=867f2ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867f2ccc",
  null
  
)

export default component.exports